import { render, staticRenderFns } from "./relationDialog.vue?vue&type=template&id=34ca3084"
import script from "./relationDialog.vue?vue&type=script&lang=js"
export * from "./relationDialog.vue?vue&type=script&lang=js"
import style0 from "./relationDialog.vue?vue&type=style&index=0&id=34ca3084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports